import { Field } from "@ui/components/Field";
import { DateField, DateFieldInput, type DateFieldProps, DateFieldSegment } from "@ui/primitives/DateField";
import type { DateValue } from "@ui/primitives/shared";
import type { ReactNode } from "react";
import { dateSegmentClassName } from "./date-segment";

export interface StandardDateFieldProps<T extends DateValue> extends DateFieldProps<T> {
  label: string;
  isInvalid?: boolean;
  errorMessage?: ReactNode;
  leadIcon?: ReactNode;
  /** Styles the field's outer box — see StandardTextField's `className`. */
  className?: string;
}

export function StandardDateField<T extends DateValue>({
  label,
  errorMessage,
  leadIcon,
  className,
  ...props
}: StandardDateFieldProps<T>) {
  return (
    <Field className={className} isInvalid={props.isInvalid}>
      <DateField {...props} className="contents">
        <Field.Label>{label}</Field.Label>
        <Field.Control asGroup leadIcon={leadIcon}>
          <DateFieldInput className="flex flex-1 items-center">
            {(segment) => <DateFieldSegment segment={segment} className={dateSegmentClassName} />}
          </DateFieldInput>
        </Field.Control>
        {props.isInvalid && errorMessage && <Field.Error>{errorMessage}</Field.Error>}
      </DateField>
    </Field>
  );
}
